import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, } from 'rxjs';
import { map, catchError, } from 'rxjs/operators';
import { caseManagerList, GetCaseListBo } from './case-manager.model';
import { ErrorService } from 'src/app/service/error.service';

@Injectable()
export class casemanagerHTTPService {
  constructor(private http: HttpClient, public errorService: ErrorService) { }

  getCaseManagerList(paramsData: GetCaseListBo): Observable<caseManagerList[]> {
    let url = "api/CaseManager/GetCaseManagerListFilter?";
    return this.http.post<caseManagerList[]>(url, paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  saveupdate(saveList: caseManagerList): Observable<any> {
    let url = "api/CaseManager/SaveCaseManager";
    return this.http.post<any>(url, saveList, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  delete(params: URLSearchParams) {
    let url = "api/CaseManager/DeleteCaseManager?";
    return this.http.delete<any>(url + params).pipe(
      map(data => data),
      catchError(this.errorService.handleError))
  }

  gettotalCount(paramsData: URLSearchParams): Observable<number> {
    let url = "api/CaseManager/GetCaseManagerList_Count?";
    return this.http.get<number>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
}